module.exports = __webpack_public_path__ + "static/media/azureFunction.e00a368b.png";